module.exports = __webpack_public_path__ + "img/product-7.ab0ca81c.png";